import { createSimpleStore, useSimpleStore } from '@passionware/simple-store';
import { ReadWriteApi } from '../ts/readWriteApi';
import { rd, RemoteData } from '@passionware/monads';
import { promiseState } from '@passionware/platform-react';

export interface ReadWriteApiStore<T> {
  useValue: () => RemoteData<T>;
  ensureValue: () => Promise<RemoteData<T>>;
  setValue: (value: T) => void;
}

export function createReadWriteApiStore<T>(
  readWriteApi: ReadWriteApi<T>
): ReadWriteApiStore<T> {
  const store = createSimpleStore<RemoteData<T>>(rd.ofIdle());
  const sync = promiseState.syncRemoteData(store.setNewValue);

  const loadData = async () => readWriteApi.load();

  sync.track(loadData());

  return {
    useValue: () => useSimpleStore(store),
    ensureValue: async () => store.waitFor(rd.isSuccess),
    setValue: value => {
      store.setNewValue(rd.of(value));
      void readWriteApi.save(value);
    }
  };
}
